import { PackageProps, stateStatusType } from './actionType';

export interface FetchPackagesState {
  isLoading: boolean;
  error: string | null;
  packages: PackageProps[] | null;
  status: stateStatusType | null;
}

export interface GenericPackageState {
  isLoading: boolean;
  error: string | null;
  status: stateStatusType | null;
}

export const initialFetchPackagesState: FetchPackagesState = {
  isLoading: false,
  error: null,
  packages: null,
  status: null,
};

export const initialGenericPackageState: GenericPackageState = {
  isLoading: false,
  error: null,
  status: null,
};

export interface PackagesState {
  fetchPackagesState: FetchPackagesState;
  createPackageState: GenericPackageState;
  updatePackageState: GenericPackageState;
  deletePackageState: GenericPackageState;
  children?: React.ReactNode;
}

export const initialState: PackagesState = {
  fetchPackagesState: initialFetchPackagesState,
  createPackageState: initialGenericPackageState,
  updatePackageState: initialGenericPackageState,
  deletePackageState: initialGenericPackageState,
};




